import Chart from 'chart.js/auto';
window.Chart = Chart;

// Moment.js
import moment from "moment";
import "moment/locale/it";

import 'chartjs-adapter-moment';

moment.locale('it');